import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { catchError, EMPTY, forkJoin, of } from 'rxjs';
import { InputOption } from 'app/shared/components';
import { PortalOrganisation } from 'app/domain/organisations/portal-organisation.model';
import { OrganisationApiService } from 'app/domain/organisations/api/organisation-api.service';
import { httpStatusOf } from 'app/shared/utils/http-status-of';

export interface CaseCreationOptions {
  configurations: InputOption[];
  organisations: PortalOrganisation[];
}

const describeLoadFailure = (error: unknown): string => {
  const source = error instanceof HttpErrorResponse && error.url ? `, ${error.url}` : '';
  return `Portal options could not be loaded (status ${httpStatusOf(error)}${source})`;
};

export const caseCreationOptionsResolver: ResolveFn<CaseCreationOptions | RedirectCommand> = () => {
  const service = inject(OrganisationApiService);
  const router = inject(Router);
  const logger = inject(NGXLogger);

  return forkJoin({
    configurations: service.getConfigurations(),
    organisations: service.getOrganisations(),
  }).pipe(
    catchError((error: unknown) => {
      logger.error(describeLoadFailure(error));
      return router.navigated ? EMPTY : of(new RedirectCommand(router.parseUrl('/')));
    }),
  );
};
